export const seoRouteNames = {
    default: 'seo',
}